import script from "./ConversationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__